import {createRouter, createWebHistory} from "vue-router";

const apresentacaoDepartamento = () => import('./containers/homedepartamento.vue');
const pessoasDepartamento = () => import('./containers/pessoas.vue');
const noticiasDepartamento = () => import('./containers/noticias.vue');
const testemunhosContainer = () => import('./containers/testemunhos.vue');
const repositorioDepartamento = () => import('./containers/repositorio.vue');
const departamentoContainer = () => import('./containers/departamento.vue');

let baseUrl = window.currentLanguage == "en" ?
    process.env.VUE_APP_BASEURLEN : process.env.VUE_APP_BASEURL;

if(window.currentLanguage == null){
    baseUrl = "/";
}

const router = createRouter({
    routes:[
        {
            path:'/:id',
            component: departamentoContainer,
            redirect:{ 'name': 'apresentacao' },
            children:[
                {
                    path:'/:id/apresentacao',
                    component: apresentacaoDepartamento,
                    name: 'apresentacao'
                },
                {
                    path:'/:id/pessoas',
                    component: pessoasDepartamento,
                    name: 'pessoas'
                },
                {
                    path:'/:id/noticias',
                    component: noticiasDepartamento,
                    name: 'noticias'
                },
                {
                    path:'/:id/testemunhos',
                    component: testemunhosContainer,
                    name: 'testemunhos'
                },
            ]
        },
        { path:'/', component: repositorioDepartamento }
    ],
    history: createWebHistory(baseUrl),
    scrollBehavior() {
        // always scroll to top
        return { top: 0 }
    },
});

export default router;